(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hemmadjur-welcome"] && !Shopify.designMode) return;
  try {
    
(() => {
  const pendingKey = 'hdWelcomePending';
  const readPending = () => {
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending || Date.now() - pending.at > 600000 || pending.at > Date.now()) return null;
      return pending;
    } catch { return null; }
  };
  const bind = () => {
    const form = document.querySelector('.hd-welcome__form');
    if (!form || form.dataset.hdWelcomeBound) return;
    form.dataset.hdWelcomeBound = 'true';
    const success = form.querySelector('[data-hd-welcome-success]');
    if (!success) {
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        try {
          const pending = { at: Date.now(), id: 'hd-welcome-' + crypto.randomUUID() };
          sessionStorage.setItem(pendingKey, JSON.stringify(pending));
        } catch {}
      });
      return;
    }
    success.focus({ preventScroll: true });
    const pending = readPending();
    if (!pending || !window.Shopify || window.Shopify.designMode ||
        window.Shopify.theme?.role !== 'main' ||
        new URLSearchParams(window.location.search).has('preview_theme_id')) return;
    let sent = false;
    const track = () => {
      const privacy = window.Shopify.customerPrivacy;
      if (sent || !privacy || privacy.marketingAllowed() !== true ||
          privacy.currentVisitorConsent().marketing !== 'yes') return;
      if (!window.fbq) {
        const fbq = function () {
          if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
          else fbq.queue.push(arguments);
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        window.fbq = fbq;
        window._fbq = window._fbq || fbq;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      window.fbq('init', '1085781794337781');
      window.fbq('trackSingle', '1085781794337781', 'CompleteRegistration',
        { content_name: 'Hemmadjur medlemskap', status: true }, { eventID: pending.id });
      sent = true;
      try { sessionStorage.removeItem(pendingKey); } catch {}
    };
    document.addEventListener('visitorConsentCollected', track);
    if (window.Shopify.customerPrivacy) track();
    else if (typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        error => { if (!error) track(); });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
